import { UserDetails } from "domain/user";
import { conditionalRulesService } from "services/conditional-rules/ConditionalRulesService";
import { userSessionService } from "services/user/UserSessionService";
import { TenantDetails } from "store/tenantDetails";
import { logger } from "utils/logging";

export interface UserActionsDispatch {
    setUser: (user: UserDetails) => void;
    clearAllTenantDetails: () => void;
    pushTenantDetails: (details: TenantDetails) => void;
}

export function storeAndUpdateUserDetails(user: UserDetails, dispatch: UserActionsDispatch): void {
    userSessionService.storeUser(user);
    dispatch.setUser(user);
    dispatch.clearAllTenantDetails();
    dispatch.pushTenantDetails({
        uuid: user.tenantUuid,
        featureLicenses: user.featureLicenses,
        type: user.tenantType,
        region: user.region,
        tenantName: user.username.split("@")[0],
        loginMethod: user.tenantLoginMethod,
        tenantTier: user.tier,
        licensingModel: user.licensingModel,
        contractType: user.contractType,
        expirationDate: user.tenantExpirationDate,
    });
    fetchAndStoreConditionalRules();
}

function fetchAndStoreConditionalRules(): void {
    conditionalRulesService.fetchRules().catch((e) => {
        logger.error("Failed to fetch conditional rules", e);
    });
}
